export default "__VITE_ASSET__1e795d6d__"